import "core-js/modules/es6.regexp.flags";
import "core-js/modules/es6.function.name";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import compact from 'lodash/compact';
import delay from 'lodash/delay';
import { mapGetters } from 'vuex';
import { FLASH_TIMER } from '~/const/timers';
import Heart from '~/components/atoms/Global/Heart.vue';
var VARIANTS_DISPLAYED = 4;
export default {
  name: 'ProductItem',
  components: {
    Heart: Heart
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    withVariants: {
      type: Boolean,
      default: false
    },
    withWishlist: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      touch: false,
      showSecondImage: false,
      hoverVariant: false,
      hoverVariantArea: false
    };
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    displayedVariants: function displayedVariants() {
      if (!this.product.variants[0].products.length) {
        return [];
      }

      var curProductVariant = {
        images: [this.product.images[0]],
        name: this.product.name,
        reference: this.product.reference,
        slug: this.product.slug
      };
      var variants = this.product.variants[0].products.slice(0, VARIANTS_DISPLAYED);
      variants.unshift(curProductVariant);
      return variants;
    },
    totalVariants: function totalVariants() {
      if (this.product.variants[0].products.length < VARIANTS_DISPLAYED) {
        return false;
      }

      var result = this.product.variants[0].products.length - VARIANTS_DISPLAYED;

      if (result === 0 || result + 2 === 0) {
        return false;
      }

      return {
        desktop: result,
        mobile: result + 2
      };
    },
    variantsVisibility: function variantsVisibility() {
      return this.withVariants && this.product.variants.length && this.product.variants[0].count;
    },
    currentItem: function currentItem() {
      if (this.hoverVariant) {
        return this.hoverVariant;
      }

      return this.product;
    },
    primaryFlagPayload: function primaryFlagPayload() {
      if (this.product.flag.primary) return this.product.flag.primary;
      return this.product.flags ? this.product.flags[0] : null;
    },
    secondaryFlagPayload: function secondaryFlagPayload() {
      if (this.product.flag.secondary) return this.product.flag.secondary;
      return this.product.flags && this.product.flags.length > 1 ? this.product.flags[1] : null;
    },
    primaryFlag: function primaryFlag() {
      return this.$tc(this.primaryFlagPayload.name, this.primaryFlagPayload.payload, {
        x: this.primaryFlagPayload.payload
      });
    },
    secondaryFlag: function secondaryFlag() {
      return this.$tc(this.secondaryFlagPayload.name, this.secondaryFlagPayload.payload, {
        x: this.secondaryFlagPayload.payload
      });
    },
    formattedName: function formattedName() {
      return compact([this.currentItem.line ? this.currentItem.line.toUpperCase() : null, this.currentItem.name, this.currentItem.quantity > 1 ? this.$t('lot', {
        x: this.currentItem.quantity
      }) : null]).join(' - ');
    },
    currentPrice: function currentPrice() {
      return this.product.price.sales.amount ? this.product.price.sales.formatted : this.product.price.base.formatted;
    },
    currentImage: function currentImage() {
      if (this.showSecondImage && this.product.images[1] && !this.hoverVariant) {
        return this.product.images[1];
      }

      if (this.hoverVariant) {
        return this.hoverVariant.images[0];
      }

      return this.product.images[0];
    }
  }),
  methods: {
    toggleImage: function toggleImage(state) {
      var _this = this;

      delay(function () {
        if (_this.touch) return;
        _this.showSecondImage = state;
      }, FLASH_TIMER);
    }
  }
};